import { render, staticRenderFns } from "./EditorArchive.vue?vue&type=template&id=df5c432e"
import script from "./EditorArchive.vue?vue&type=script&lang=ts"
export * from "./EditorArchive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df5c432e')) {
      api.createRecord('df5c432e', component.options)
    } else {
      api.reload('df5c432e', component.options)
    }
    module.hot.accept("./EditorArchive.vue?vue&type=template&id=df5c432e", function () {
      api.rerender('df5c432e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/videoArchive/components/EditorArchive.vue"
export default component.exports